export default __webpack_public_path__ + "alert_preferences.89d65cef.png";